export default {
  data() {
    return {
      isChecked: false,
      label: '非選択'
    }
  },
  methods: {
    onChecked() {
      this.isChecked = !this.isChecked
      this.label = this.label === '非選択' ? '選択中' : '非選択'
    }
  }
}
